'use client'

// Replaces the root layout when the layout itself fails, so it carries its own
// <html> and <body> and only inline styles.
export default function GlobalError({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <html lang="en">
      <body style={{ margin: 0, minHeight: '100vh', display: 'grid', placeContent: 'center', background: '#FDF8E9', fontFamily: 'system-ui, sans-serif', color: '#1D4749', textAlign: 'center', padding: '0 16px' }}>
        <h1 style={{ fontSize: 24 }}>Dharmayana couldn&apos;t load</h1>
        <p style={{ color: '#565151' }}>Something went wrong on our side. Please try again in a moment.</p>
        <p>
          <button onClick={() => reset()} style={{ background: '#1D4749', color: '#fff', border: 0, borderRadius: 6, padding: '8px 16px', cursor: 'pointer' }}>
            Try again
          </button>
        </p>
      </body>
    </html>
  )
}
